import React, { useState } from 'react'
import {
  Box,
  Paper,
  Typography,
  Grid,
  Divider,
  Button,
} from '@material-ui/core'
import { useParams, useHistory } from 'react-router-dom'
import { HelpCircle as HelpCircleIcon } from 'react-feather'

import {
  Container,
  ContentHeader,
  DialogLogs,
  DriveTour,
  LoadingFeedback,
  Page,
  MenuButton,
} from 'components'

import {
  SubCategoryTable,
  ChangeStatusCategoryButton,
  DeadlineForm,
} from './components'

import RegisterResponsiblesDialog from './components/CategoryEdit/components/RegisterResponsiblesDialog'

import { AddSubCategoryButton } from './components/SubCategoryTable/components'

import * as service from 'service'
import constants from 'constants/index'
import helpers from 'helpers'

import useFetch from 'hooks/useFetch'
import useSnackbar from 'hooks/useSnackbar'
import useStyles from './styles'

const ComplaintCategoryEdit = () => {
  const [openTour, setOpenTour] = useState(false)
  const [openLogDialog, setOpenLogDialog] = useState(false)
  const [loading, setLoading] = useState(false)
  const [responseLog, setResponseLog] = useState([])
  const [registerResponsiblesOpen, setRegisterResponsiblesOpen] =
    useState(false)

  const { categoryId } = useParams()
  const classes = useStyles()
  const history = useHistory()
  const snackbar = useSnackbar()

  const {
    COMPLAINT_CATEGORY_EDIT_STEPS_OBJECT,
    COMPLAINT_CATEGORY_EDIT_DRIVER_STEP_1,
    COMPLAINT_CATEGORY_EDIT_DRIVER_STEP_2,
    COMPLAINT_CATEGORY_EDIT_DRIVER_STEP_3,
    COMPLAINT_CATEGORY_EDIT_DRIVER_STEP_4,
  } = constants.tours.complaint

  const handleOpenTour = () => {
    setOpenTour(true)
  }

  const handleOpenLogs = async () => {
    try {
      setLoading(true)
      const responseLogs = await service.dponet.complaintCategories.logs(
        categoryId,
      )
      const updatedlogs = helpers.logs.changeLogs(
        responseLogs?.data?.dponetAudits || [],
      )
      setResponseLog(updatedlogs)
      setOpenLogDialog(true)
    } catch (error) {
      setOpenLogDialog(false)
      snackbar.open({
        message:
          helpers.formatters.errorMessage(error, false) ||
          error?.error?.message,
        variant: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  const {
    response: responseCategory,
    isLoading: isLoadingCategory,
    refresh: refreshCategory,
  } = useFetch(service.dponet.complaintCategories.show, categoryId, [
    categoryId,
  ])

  const category = responseCategory?.data?.complaintCategory

  return (
    <Page title="Editar Categoria">
      <Container maxWidth={false}>
        <LoadingFeedback open={isLoadingCategory || loading} />
        <ContentHeader
          title="Editar Categoria"
          id={COMPLAINT_CATEGORY_EDIT_DRIVER_STEP_1}
        >
          <Button
            variant="contained"
            color="primary"
            startIcon={<HelpCircleIcon size={20} />}
            onClick={handleOpenTour}
            fullWidth
          >
            Tutorial
          </Button>
          <MenuButton id={COMPLAINT_CATEGORY_EDIT_DRIVER_STEP_2}>
            <Button
              color="secondary"
              fullWidth
              size="small"
              onClick={handleOpenLogs}
            >
              Histórico de alterações
            </Button>
            <ChangeStatusCategoryButton
              category={category}
              onRefresh={refreshCategory}
            />
            <Button
              color="secondary"
              fullWidth
              size="small"
              onClick={() => setRegisterResponsiblesOpen(true)}
            >
              Registrar Responsáveis
            </Button>
          </MenuButton>
        </ContentHeader>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Paper
              className={classes.paper}
              id={COMPLAINT_CATEGORY_EDIT_DRIVER_STEP_3}
            >
              <DeadlineForm
                category={category}
                categoryId={categoryId}
                onRefresh={refreshCategory}
                setLoading={setLoading}
              />
            </Paper>
          </Grid>

          <Grid item xs={12}>
            <Paper id={COMPLAINT_CATEGORY_EDIT_DRIVER_STEP_4}>
              <Box
                p={2}
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <Typography color="primary" variant="subtitle1">
                  Gerenciar de Subcategorias
                </Typography>
                <AddSubCategoryButton
                  categoryId={parseInt(categoryId)}
                  onSuccess={refreshCategory}
                  disabled={category?.customizable}
                />
              </Box>
              <Divider />
              <SubCategoryTable
                categoryId={categoryId}
                isCustomizable={category?.customizable}
              />
            </Paper>
          </Grid>

          <Grid item xs={12}>
            <Box display="flex" justifyContent="flex-end">
              <Button variant="outlined" onClick={() => history.goBack()}>
                Voltar
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Container>
      {!loading && (
        <DialogLogs
          logs={
            helpers.functions.isEmpty(responseLog) ? undefined : responseLog
          }
          open={openLogDialog}
          setOpen={setOpenLogDialog}
          showRegisterSession={false}
          refresh={handleOpenLogs}
        />
      )}
      {category && (
        <RegisterResponsiblesDialog
          open={registerResponsiblesOpen}
          onClose={() => setRegisterResponsiblesOpen(false)}
          category={category}
          onRefresh={refreshCategory}
        />
      )}
      <DriveTour
        stepsMatrix={COMPLAINT_CATEGORY_EDIT_STEPS_OBJECT}
        open={openTour}
        setOpen={setOpenTour}
      />
    </Page>
  )
}

export default ComplaintCategoryEdit
